import { useState } from 'react';
import { useHistory } from 'react-router';

import { Controller, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.min.css';
import 'swiper/modules/pagination/pagination.min.css';

import './Slideshow.css';

interface Props {
    images: []
}

const Slideshow: React.FC<Props> = (props) => {
    const history = useHistory();

    const [firstSwiper, setFirstSwiper] = useState(null as any);
    const [secondSwiper, setSecondSwiper] = useState(null as any);

    return <>
        <div className="slideshow">
            <Swiper
                modules={[Controller, Pagination]}
                pagination={true}
                dir="ltr"
                onSwiper={setFirstSwiper}
                controller={{ control: secondSwiper }}>
                {props.images.map((item: any, index: number) => {
                    return <SwiperSlide className='slide' onClick={() => history.push(history.location.pathname + '/images', { images: props.images, index: index })}>
                        <img style={{ backgroundImage: 'url(' + item['url'] + ')' }}/>
                    </SwiperSlide>
                })}
            </Swiper>
        </div>
    </>
}

export default Slideshow